'use strict';

// Func = limiting Scope for this file

function updateLanguage() {
	var lg = document.getElementById("selectLanguage").value;
	changeLanguage(lg);
	ga('send', 'event', 'language', 'click', lg);
}

setTimeout(function () {
	$('#start-content').css('opacity', 1);
}, 300);

(function () {
	function scrollDown() {
		var top = $(document).scrollTop();
		if (top > 150) {
			$('.homepage #header').addClass('scroll');
		} else {
			$('.homepage #header').removeClass('scroll');
		}
	}

	$(document).ready(function () {

		var hasEvent = false;
		var xWindowSize = window.matchMedia("(max-width: 1200px)");
		var mainMenuLi = $("#primary-nav > #privary-navigation > li");
		var mainMenuLiA = mainMenuLi.children('a');

		behaviorMenu();
		xWindowSize.addListener(behaviorMenu);

		//Main Nav Dropdown
		function behaviorMenu() {
			if (xWindowSize.matches) {
				hasEvent = false;
				mainMenuLi.unbind();
				mainMenuLi.click(function (e) {
					mainMenuLi.removeClass('active');
					$(this).addClass('active');
					//$('ul.submenu').css('display', 'none');
					if ($(this).children('ul').length > 0) {
						$('ul.submenu', this).css('display', 'block');
					}
				});
				mainMenuLiA.click(function (e) {
					if ($(this).siblings('ul').length > 0) {
						e.preventDefault();
					}
				});
			} else {
				if (!hasEvent) {
					hasEvent = true;
					mainMenuLiA.unbind();
					mainMenuLi.hover(function () {
						$(this).addClass("hover");
						$('ul.submenu', this).fadeIn(200);
					}, function () {
						$(this).removeClass("hover");
						$('ul.submenu', this).fadeOut(200);
					});
				}
			}
		}

		// $('.btn-read-more').on('click', function() {
		// 	let elementToShow = $(this).attr('data-item');
		// 	if($(this).html() == "Read More") {
		// 		$(this).html('Read Less');
		// 	} else {
		// 		$(this).html('Read More');
		// 	}
		// 	$('#' + elementToShow).toggle('slow');
		// 	$('.copy-extra').toggleClass('show-extra-content');
		// });

		$('.hamburguerMenu').on('click', function () {
			$(".container-booking").removeClass('show-booking');
			$('#primary-nav').addClass('show');
			$('.overlay').addClass('show');
		});

		$('.close-menu').on('click', function () {
			$('#primary-nav').removeClass('show');
			$('.overlay').removeClass('show');
		});

		$(".home-gallery__content__image").on("click", function () {
			window.location.href = window.location.href + "photos";
		});

		$(".open-booking").on('click', function () {
			$(".container-booking").toggleClass('show-booking');
			if ($(this).text() === "Close") {
				$(this).text('Book Now');
			} else {
				$(this).text('Close');
			}
		});

		$('.arrow-home').on('click', function () {
			$('html, body').animate({ scrollTop: $('.intro-content-home').offset().top - 40 }, 'slow');
		});

		$('select#selectLanguage').val($('body').attr('lang'));

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown();
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function () {
			//$(this).addClass("hover");
			$('ul.submenu', this).fadeIn(200);
		}, function () {
			//$(this).removeClass("hover");
			$('ul.submenu', this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		var DATE_STYLE = [true];
		function calendarRange(date) {
			var d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
			var d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight';
			} else {
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		var DATE_FORMAT = $("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format") ? $("#CheckIn").data("format") : "dd M";
		$("#CheckIn").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: function beforeShowDay(date) {
				return calendarRange(date);
			},
			onSelect: function onSelect(selectedDate) {
				var getDate = $(this).datepicker('getDate');
				var newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$("#CheckOut").datepicker("setDate", newDate);
				$("#CheckOut").datepicker("option", "minDate", selectedDate);
				$("input[name=CIM]").val(getDate.getMonth() + 1);
				$("input[name=CID]").val(getDate.getDate());
				$("input[name=CIY]").val(getDate.getFullYear());
				$("input[name=COM]").val(newDate.getMonth() + 1);
				$("input[name=COD]").val(newDate.getDate());
				$("input[name=COY]").val(newDate.getFullYear());
			}
		});
		$("#CheckOut").datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: function beforeShowDay(date) {
				return calendarRange(date);
			},
			onSelect: function onSelect(selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
				var getDateCheckout = $(this).datepicker('getDate');
				$("input[name=COM]").val(getDateCheckout.getMonth() + 1);
				$("input[name=COD]").val(getDateCheckout.getDate());
				$("input[name=COY]").val(getDateCheckout.getFullYear());
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
	});
})();